import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { locumsFeatureKey, reducers } from './reducers';
import { LocumsJobEffects } from './effects/job.effects';
import { EnvironmentProviders } from '@angular/core';

export const provideLocumsStore = (): EnvironmentProviders[] => [
    provideState(locumsFeatureKey, reducers),
    provideEffects([LocumsJobEffects])
];
